import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import ReconciliationDetailsPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/AccountReconciliationPage/ReconciliationDetails";

function ReconciliationDetails() {
  const [customers, setCustomers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [openingBalance, setOpeningBalance] = useState("");
  const [closingBalance, setClosingBalance] = useState("");
  const { state } = useLocation();

  useEffect(() => {
    handleGetAccountRencociliationList()
  }, []);

  useEffect(() => {
    handleGetCustomers();
    handleGetVendors();
  }, []);


  const handleGetCustomers = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getCustomer();
      if (result?.success) {
        setCustomers(result?.data?.customers);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleGetVendors = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getSupplier();
      if (result.success) {
        setVendors(result?.data?.suppliers);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleGetAccountRencociliationList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleGetAccountReconciliationDetails(
        state.reconciliationId,
        text,
        sort,
        page,
      );
      if (result?.success) {
        setData(result?.data?.reconciledTransactionIds);
        setClosingBalance(result?.data?.closingBalance)
        setEndDate(result?.data?.endDate)
        setOpeningBalance(result?.data?.openingBalance)
        setStartDate(result?.data?.startDate)
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return <ReconciliationDetailsPage
    data={data}
    closingBalance={closingBalance}
    endDate={endDate}
    openingBalance={openingBalance}
    startDate={startDate}
    customers={customers}
    vendors={vendors}
    bankName={state.bankName}
  />;
}

export default ReconciliationDetails;
